/* ═════════════════════════════════════════════════
   DWL — eigen zoeksuggesties

   VOLGORDE: COLLECTIES → PRODUCTEN → PAGINA'S
   Bij deze winkel zíjn de collecties de merken (Jurassic, Crypto,
   Wildlife…). Wie "jurassic" typt wil meestal de hele set zien.

   ⚠ PRODUCTEN MET APP-OPTIES — zie NEEDS_OPTIONS.
   Bij de Signduck komen kleur en tekst uit een app, niet uit Shopify:
   het product heeft in Shopify alleen `Default Title` als variant. Wie
   dat direct toevoegt krijgt een Signduck zónder kleur en zónder tekst
   in de wagen — een bestelling die je niet kunt uitvoeren. Zulke
   producten krijgen "Choose options" en gaan naar de productpagina.
   Dit is niet automatisch te herkennen; zet nieuwe handles erbij.

   LEEG VELD: BESTSELLERS OF DICHT?
   Bestsellers verschijnen alléén als het veld focus krijgt. Elke andere
   route naar een leeg veld betekent dat de bezoeker aan het weghalen is,
   en dan hoort het paneel dicht te gaan.

   ⚠ HIER ZAT EEN BUG — NIET TERUGDRAAIEN
   Eerder stond er:
       var wasFilled = lastValue.trim().length > 0;
       if (!fromFocus && wasFilled) { hide(); return; }
       showBestsellers(panel);
   Het kruisje in de header zet field.value op '' en vuurt daarna een
   input-event af. Dat kwam hier binnen met een leeg veld. Had de
   bezoeker nooit getypt — het paneel stond open omdat hij op de loep
   klikte — dan was wasFilled false en viel de code door naar
   showBestsellers(). Je klikte het paneel weg en het kwam meteen terug.

   Tweede laag van dezelfde bug: de focus-listener opende het paneel
   opnieuw zodra de focus na het sluiten terugstuiterde naar het veld.
   Daarom onthouden we wánneer er gesloten is en negeren we focus die
   binnen een halve seconde daarna komt.

   ⚠ NA TOEVOEGEN: DWLCart.refreshCartUI() AANROEPEN — dit thema heeft
   een eigen winkelwagensysteem; zonder die aanroep klópt de wagen wel
   maar toont de drawer de oude inhoud.

   ⚠ WOORDBEGIN-MATCHING (prefix=last): Shopify matcht standaard alleen
   hele woorden; "deta" vond daardoor géén Detailed Ducks.
   ══════════════════════════════════════════════════ */
(function () {

  var T = {
    add:         'Add to cart',
    added:       'Added',
    soldOut:     'Sold out',
    view:        'View',
    choose:      'Choose options',
    seeAll:      'See all results for',
    noResults:   'No results for',
    popular:     'Popular right now',
    collections: 'Collections',
    products:    'Products',
    pages:       'Pages',
    labelColl:   'Collection',
    labelPage:   'Page'
  };

  /* Producten waarvan de opties uit een app komen: nooit direct
     toevoegen, altijd naar de productpagina. Op handle. */
  var NEEDS_OPTIONS = ['signducks'];

  /* Collecties die nooit als suggestie mogen verschijnen. Op handle. */
  var EXCLUDE_COLLECTIONS = [];

  var MIN_CHARS   = 2;
  var DEBOUNCE    = 250;
  var LIMIT_COLL  = 3;
  var LIMIT_PROD  = 6;
  var LIMIT_PAGE  = 3;
  var BESTSELLERS = 'bestsellers';

  /* Hoe lang na een bewuste sluiting een focus genegeerd wordt. */
  var REOPEN_GUARD = 500;

  function root() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (r || '/').replace(/\/$/, '');
  }

  function searchUrl(term) {
    return root() + '/search?q=' + encodeURIComponent(term) +
           '&type=product,page,article&options[prefix]=last';
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function money(v) {
    if (v == null || v === '') return '';
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    return '\u20ac' + n.toFixed(2).replace('.', ',');
  }

  /* De API levert afbeeldingen niet overal in dezelfde vorm: bij
     producten een string, bij collecties soms een object met url of src,
     soms onder featured_image. Alle vormen afvangen. */
  function imageOf(item) {
    if (!item) return '';
    var candidates = [item.image, item.featured_image, item.thumbnail];
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      if (!c) continue;
      if (typeof c === 'string') return c;
      if (c.url) return c.url;
      if (c.src) return c.src;
    }
    return '';
  }

  function thumb(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url.replace(/(\.[a-z]{3,4})(\?.*)?$/i, '_200x$1$2');
  }

  function handleOf(url, kind) {
    var m = String(url || '').match(new RegExp('/' + (kind || 'products') + '/([^?#/]+)'));
    return m ? m[1] : '';
  }

  function needsOptions(url) {
    var h = handleOf(url, 'products').toLowerCase();
    for (var i = 0; i < NEEDS_OPTIONS.length; i++) {
      if (h === NEEDS_OPTIONS[i]) return true;
    }
    return false;
  }

  function refreshCart() {
    try {
      if (window.DWLCart && typeof window.DWLCart.refreshCartUI === 'function') {
        window.DWLCart.refreshCartUI();
      }
    } catch (e) {}

    fetch(root() + '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var els = document.querySelectorAll('.cart-count');
        for (var i = 0; i < els.length; i++) els[i].textContent = cart.item_count;
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart, bubbles: true }));
      })
      .catch(function () {});
  }

  function flash(btn, text, cls) {
    var original = btn.dataset.label || btn.innerHTML;
    btn.dataset.label = original;
    btn.classList.add(cls);
    btn.innerHTML = text;
    setTimeout(function () {
      btn.classList.remove(cls);
      btn.innerHTML = original;
      btn.disabled = false;
    }, 1600);
  }

  function postToCart(btn, variantId) {
    btn.disabled = true;
    btn.classList.add('is-busy');

    fetch(root() + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        btn.classList.remove('is-busy');
        if (!res.ok) throw new Error('failed');
        refreshCart();
        flash(btn, T.added, 'is-done');
      })
      .catch(function () {
        btn.classList.remove('is-busy');
        flash(btn, T.view, 'is-error');
      });
  }

  function showVariants(item, variants) {
    var box = item.querySelector('.dwl-suggest__variants');
    if (box) { box.remove(); return; }

    box = document.createElement('div');
    box.className = 'dwl-suggest__variants';

    var html = '';
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      html += '<button type="button" class="dwl-suggest__variant" data-variant="' + v.id + '"' +
              (v.available ? '' : ' disabled') + '>' +
              esc(v.title) + '</button>';
    }
    box.innerHTML = html;
    item.appendChild(box);

    var btn = item.querySelector('.dwl-suggest__add');

    box.addEventListener('click', function (e) {
      var chip = e.target.closest('.dwl-suggest__variant');
      if (!chip || chip.disabled) return;
      e.preventDefault();
      e.stopPropagation();

      var chips = box.querySelectorAll('.dwl-suggest__variant');
      for (var i = 0; i < chips.length; i++) chips[i].classList.remove('is-selected');
      chip.classList.add('is-selected');

      if (btn) {
        btn.dataset.variant = chip.getAttribute('data-variant');
        btn.dataset.label = T.add;
        btn.innerHTML = T.add;
        btn.disabled = false;
      }
    });
  }

  function addToCart(btn, url) {
    /* App-opties: nooit blind toevoegen. */
    if (btn.dataset.needsOptions === '1') { window.location.href = url; return; }

    if (btn.dataset.variant) {
      postToCart(btn, parseInt(btn.dataset.variant, 10));
      return;
    }

    var handle = handleOf(url, 'products');
    if (!handle) { window.location.href = url; return; }

    var item = btn.closest('.dwl-suggest__item');
    btn.disabled = true;
    btn.classList.add('is-busy');

    fetch(root() + '/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        btn.classList.remove('is-busy');
        btn.disabled = false;

        var vs = (p && p.variants) || [];
        var sellable = vs.filter(function (v) { return v.available; });

        if (!sellable.length) { flash(btn, T.soldOut, 'is-error'); return; }

        if (vs.length > 1) {
          btn.dataset.label = T.choose;
          btn.innerHTML = T.choose;
          showVariants(item, vs);
          return;
        }

        postToCart(btn, sellable[0].id);
      })
      .catch(function () {
        btn.classList.remove('is-busy');
        btn.disabled = false;
        window.location.href = url;
      });
  }

  function panelFor(field) {
    var form = field.form || field.closest('form');
    if (!form) return null;
    var panel = form.parentElement && form.parentElement.querySelector('.dwl-suggest');
    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'dwl-suggest';
      panel.hidden = true;
      form.insertAdjacentElement('afterend', panel);

      panel.addEventListener('click', function (e) {
        var btn = e.target.closest('.dwl-suggest__add');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        addToCart(btn, btn.getAttribute('data-url'));
      });
    }
    return panel;
  }

  function productRow(p) {
    var soldOut = p.available === false;
    var opts = needsOptions(p.url);
    var img = imageOf(p);
    var label = soldOut ? T.soldOut : (opts ? T.choose : T.add);

    return '<li class="dwl-suggest__item">' +
             '<a class="dwl-suggest__link" href="' + esc(p.url) + '">' +
               (img
                 ? '<img class="dwl-suggest__img" src="' + esc(thumb(img)) + '" alt="" loading="lazy">'
                 : '<span class="dwl-suggest__img"></span>') +
               '<span class="dwl-suggest__text">' +
                 '<span class="dwl-suggest__title">' + esc(p.title) + '</span>' +
                 (money(p.price) ? '<span class="dwl-suggest__price">' + money(p.price) + '</span>' : '') +
               '</span>' +
             '</a>' +
             '<button type="button" class="dwl-suggest__add' + (opts ? ' is-options' : '') + '"' +
               ' data-url="' + esc(p.url) + '"' +
               (opts ? ' data-needs-options="1"' : '') +
               (soldOut ? ' disabled' : '') + '>' +
               label +
             '</button>' +
           '</li>';
  }

  function linkRow(item, label, withImage) {
    var img = imageOf(item);
    return '<li class="dwl-suggest__item dwl-suggest__item--link">' +
             '<a class="dwl-suggest__link" href="' + esc(item.url) + '">' +
               (withImage
                 ? (img
                     ? '<img class="dwl-suggest__img" src="' + esc(thumb(img)) + '" alt="" loading="lazy">'
                     : '<span class="dwl-suggest__img"></span>')
                 : '') +
               '<span class="dwl-suggest__text">' +
                 '<span class="dwl-suggest__title">' + esc(item.title) + '</span>' +
               '</span>' +
               '<span class="dwl-suggest__tag">' + label + '</span>' +
             '</a>' +
           '</li>';
  }

  function group(title, rowsHtml) {
    if (!rowsHtml) return '';
    return '<p class="dwl-suggest__heading">' + title + '</p>' +
           '<ul class="dwl-suggest__list">' + rowsHtml + '</ul>';
  }

  function allowedCollection(c) {
    var h = handleOf(c.url, 'collections').toLowerCase();
    for (var i = 0; i < EXCLUDE_COLLECTIONS.length; i++) {
      if (h === EXCLUDE_COLLECTIONS[i]) return false;
    }
    return true;
  }

  function render(panel, results, term) {
    var colls = ((results && results.collections) || []).filter(allowedCollection);
    var prods = (results && results.products) || [];
    var pages = (results && results.pages) || [];
    var arts  = (results && results.articles) || [];

    if (!colls.length && !prods.length && !pages.length && !arts.length) {
      panel.innerHTML = '<p class="dwl-suggest__empty">' + T.noResults + ' “' + esc(term) + '”</p>';
      panel.hidden = false;
      return;
    }

    var html = '';

    if (colls.length) {
      html += group(T.collections, colls.slice(0, LIMIT_COLL).map(function (c) {
        return linkRow(c, T.labelColl, true);
      }).join(''));
    }

    if (prods.length) {
      html += group(T.products, prods.slice(0, LIMIT_PROD).map(productRow).join(''));
    }

    var other = pages.concat(arts);
    if (other.length) {
      html += group(T.pages, other.slice(0, LIMIT_PAGE).map(function (p) {
        return linkRow(p, T.labelPage, false);
      }).join(''));
    }

    html += '<a class="dwl-suggest__all" href="' + searchUrl(term) + '">' +
            T.seeAll + ' “' + esc(term) + '”</a>';

    panel.innerHTML = html;
    panel.hidden = false;
  }

  var bestsellersCache = null;

  function showBestsellers(panel) {
    function paint(items) {
      if (!items || !items.length) { panel.hidden = true; return; }
      panel.innerHTML = group(T.popular, items.map(productRow).join(''));
      panel.hidden = false;
    }

    if (bestsellersCache) { paint(bestsellersCache); return; }

    fetch(root() + '/collections/' + BESTSELLERS + '/products.json?limit=' + LIMIT_PROD)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var list = (d && d.products) || [];
        bestsellersCache = list.map(function (p) {
          var v = (p.variants || [])[0] || {};
          var img = (p.images || [])[0] || {};
          return {
            title: p.title,
            url: root() + '/products/' + p.handle,
            image: img.src || '',
            price: v.price || '',
            available: v.available !== false
          };
        });
        paint(bestsellersCache);
      })
      .catch(function () { panel.hidden = true; });
  }

  function wire(field) {
    if (field.dataset.dwlSuggest === '1') return;
    field.dataset.dwlSuggest = '1';

    var timer = null;
    var controller = null;
    var lastValue = field.value;
    var closedAt = 0;          /* wanneer er bewust gesloten is */

    function hide() {
      closedAt = Date.now();
      clearTimeout(timer);
      if (controller) { try { controller.abort(); } catch (e) {} }
      var p = panelFor(field);
      if (p) { p.hidden = true; p.innerHTML = ''; }
    }

    /* fromFocus: het veld kreeg focus — alleen dán zijn bestsellers
       gepast. Elke andere route naar een leeg veld is weghalen. */
    function lookup(fromFocus) {
      var term = field.value.trim();
      var panel = panelFor(field);
      if (!panel) return;

      if (term.length < MIN_CHARS) {
        lastValue = field.value;

        if (!fromFocus) { hide(); return; }

        /* Focus die meteen na het sluiten binnenkomt is de terugstuiter
           van het kruisje, geen bezoeker die opnieuw begint. */
        if (Date.now() - closedAt < REOPEN_GUARD) return;

        showBestsellers(panel);
        return;
      }

      lastValue = field.value;

      if (controller) { try { controller.abort(); } catch (e) {} }
      controller = (window.AbortController ? new AbortController() : null);

      var url = root() + '/search/suggest.json?q=' + encodeURIComponent(term) +
                '&resources[type]=collection,product,page,article' +
                '&resources[limit]=' + LIMIT_PROD +
                '&resources[options][unavailable_products]=last' +
                '&resources[options][prefix]=last';

      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (field.value.trim() !== term) return;
          var res = data && data.resources && data.resources.results;
          render(panel, res || {}, term);
        })
        .catch(function () {});
    }

    field.addEventListener('input', function () {
      /* Typen is altijd een nieuwe intentie: guard opheffen. */
      if (field.value.trim().length) closedAt = 0;
      clearTimeout(timer);
      timer = setTimeout(function () { lookup(false); }, DEBOUNCE);
    });

    field.addEventListener('focus', function () { lookup(true); });

    /* Het kruisje in een type="search"-veld vuurt 'search' af zodra het
       veld leeg is. Direct sluiten, zonder op de debounce te wachten. */
    field.addEventListener('search', function () {
      if (!field.value.trim()) {
        lastValue = '';
        hide();
      }
    });

    field.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) { lastValue = ''; hide(); }
    });

    document.addEventListener('click', function (e) {
      var panel = panelFor(field);
      if (!panel || panel.hidden) return;
      if (e.target === field || panel.contains(e.target)) return;
      hide();
    });

    /* Haakje voor de sluitknop in de header, zodat die niet via een
       input-event hoeft te werken. */
    document.addEventListener('dwl:suggest-close', function () { hide(); });
  }

  function scan() {
    var fields = document.querySelectorAll('input[type="search"][name="q"], input[name="q"][type="text"]');
    for (var i = 0; i < fields.length; i++) wire(fields[i]);
  }

  function autofocusSearchPage() {
    if (!/\/search/.test(window.location.pathname)) return;
    var q = new URLSearchParams(window.location.search).get('q');
    if (q) return;
    var field = document.querySelector('.main-search-form input[name="q"], .template-search input[name="q"]');
    if (field) setTimeout(function () { field.focus(); }, 120);
  }

  function boot() {
    scan();
    autofocusSearchPage();
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      scan();
      if (tries > 20) clearInterval(iv);
    }, 250);
    document.addEventListener('shopify:section:load', scan);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
